module.exports = __webpack_public_path__ + "img/P48-en.799338b8.png";